export const menuConstants = {
	GET_MENU_ITEMS_REQUEST: 'GET_MENU_ITEMS_REQUEST',
	GET_MENU_ITEMS_SUCCESS: 'GET_MENU_ITEMS_SUCCESS',
	GET_MENU_ITEMS_FAILED: 'GET_MENU_ITEMS_FAILED',
};
